import { useCheckoutSession } from "@circle-react/components/Paywalls/Checkout/contexts/CheckoutSessionContext";
import { updateSessionCache } from "@circle-react/components/Paywalls/Checkout/helpers/sessions/updateSessionCache";
import { paywallCheckout } from "@circle-react/helpers/urlHelpers/internalApi/paywalls/checkout";
import { useFormContext } from "react-hook-form";
import { useMutation, useQueryClient } from "react-query";

import { reactQueryPost } from "@/react/helpers/backendRequestHelpers";
import type { CheckoutSession } from "@/react/types/Paywalls/Checkout/Session";

import { getMainPaywallId } from "../../../helpers/SessionStepQueryHelper";
import { useGoToNextStep } from "../../../hooks/useGoToNextStep";

interface UseButtonActionsProps {
  stepId: number;
}

/**
 * Hook for offer page button actions.
 *
 * Note: The confirm action (payment) is now handled by PaywallCheckoutAttemptsProvider
 * via the AttemptsProvider wrapper. This hook only handles the decline action.
 */
export const useButtonActions = ({ stepId }: UseButtonActionsProps) => {
  const { setError, clearErrors } = useFormContext();
  const { session } = useCheckoutSession();
  const queryClient = useQueryClient();
  const { goToNextStep } = useGoToNextStep();

  const paywallId = getMainPaywallId(session);

  const refuseMutation = useMutation({
    mutationFn: async () => {
      clearErrors();
      return reactQueryPost<CheckoutSession>(
        paywallCheckout.sessionStep.decline(stepId),
      );
    },
    onSuccess: (updatedSession: CheckoutSession) => {
      if (paywallId) {
        updateSessionCache(queryClient, paywallId, updatedSession);
      }
      goToNextStep(updatedSession, stepId);
    },
    onError: (response: any) => {
      //  TODO: best to move to decline?
      setError("root", { message: response.message });
    },
  });

  return {
    refuseMutation,
  };
};
